var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.097,
    height: 27.84,
    viewBox: "0 0 25.097 27.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-google-play",
    "data-name": "Icon awesome-google-play",
    d: "M18.095,12.743,6.092.707,21.363,9.474l-3.269,3.269ZM2.959,0a2.114,2.114,0,0,0-1.18,1.92v24a2.114,2.114,0,0,0,1.18,1.92L16.915,13.917ZM26.084,12.269l-3.2-1.855-3.573,3.508,3.573,3.508,3.269-1.855a2.182,2.182,0,0,0-.065-3.307ZM6.092,27.139l15.272-8.767L18.095,15.1Z",
    transform: "translate(-1.779)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.9bde857b23fd6016668bcd1923a62c99.svg";
export { ForwardRef as ReactComponent };